import React from 'react'
import i18n from '../i18n/config'
export default function Button({title, specialClasses, ...props}:{title: string, specialClasses:string} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button className={`${specialClasses} font-semibold w-64 transition-all delay-75 py-3 ${i18n.language === 'en' ? "font-['Krona']" : "font-['Tajawal']"}`} {...props}>
        {title}
    </button>
  )
}
